export default function ({ $auth, redirect }) {
  if (!$auth || $auth.expirationTime * 1000 <= Date.now() || !$auth.user || !($auth.user.role == 'admin' && ($auth.user.last_name === 'Fleetch' || $auth.user.last_name === 'HONORINE'))) {
    return redirect('/vehicles')
  }
}